import Vue from 'vue'
        import VueRouter from 'vue-router'
        import Home from '../views/Home.vue'
        import { sanitizeSlug } from '../utils/slug'

        Vue.use(VueRouter)


        const routes = [
        {
                path: '/',
                name: 'Home',
                component: Home,
                meta: {
                title: 'Home | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/about',
                name: 'About',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
                meta: {
                title: 'About | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/calendar',
                name: 'Calendar',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/Calendar.vue'),
                meta: {
                title: 'Calendar | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/viewbooking',
                name: 'Viewbooking',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Viewbooking.vue'),
                meta: {
                title: 'Viewbooking | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/invoice',
                name: 'Invoice',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Invoice.vue'),
                meta: {
                title: 'Invoice | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/newbooking',
                name: 'Newbooking',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Newbooking.vue'),
                meta: {
                title: 'Newbooking | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/bookings',
                name: 'Bookings',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Bookings.vue'),
                meta: {
                title: 'Bookings | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                                {
                                name: 'description',
                                content: 'Booking details'
                                }
                        ]
                }
        },
        {
                path: '/signup',
                name: 'Signup',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Signup.vue'),
                meta: {
                title: 'Signup | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/login',
                name: 'Login',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Login.vue'),
                meta: {
                title: 'Login | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/editbooking',
                name: 'Editbooking',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Editbooking.vue'),
                meta: {
                title: 'Editbooking | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
                }
        },
        {
                path: '/mobileviewbooking',
                name: 'mobileviewbooking',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Mobileviewbooking.vue'),
                meta: {
                title: 'Viewbookings | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Mobile View bookings'
                        }
                        ]
                }
        },
        {
                path: '/payment',
                        name: 'Payment',
                        component: () => import('../views/Payment.vue'),
                        meta: {
                        title: 'Payment | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                                {
                                        name: 'description',
                                        content: 'payment page.'
                                }
                        ]
                        }
                },
        {
                path: '/appointments',
                name: 'Appointments',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/Appointments.vue'),
                meta: {
                title: 'Appointments | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Filter events.'
                        }
                        ]
                }
        },
        {
                path: '/newcustomer',
                name: 'NewCustomer',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/AddCustomer.vue'),
                meta: {
                title: 'New Customer | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Add new customer.'
                        }
                        ]
                }
        },
        {
                path: '/editcustomer',
                name: 'EditCustomer',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('../views/AddCustomer.vue'),
                meta: {
                title: 'Edit Customer | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Edit customer.'
                        }
                        ]
                }
        },
        {
                path: '/custsignup',
                name: 'signup',
                component: () => import('../views/custViews/CustSignup.vue'),
                meta: {
                title: 'Signup | Bookjoy',
                role: 'Customer',
                metaTags: [
                        {
                        name: 'description',
                        content: 'Customer Signup'
                        }
                ]
                }
        },
        {
                path: '/custlogin',
                name: 'login',
                component: () => import('../views/custViews/CustLogin.vue'),
                meta: {
                title: 'Login | Bookjoy',
                role: 'Customer',
                metaTags: [
                        {
                        name: 'description',
                        content: 'Customer Login'
                        }
                ]
                }
        },
        {
                path: '/forgotpassword',
                name: 'forgotpassword',
                component: () => import('../views/custViews/ForgotPassword.vue'),
                meta: {
                  title: 'ForgotPassword | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Forgot Password'
                    }
                  ]
                }
        },
        {
                path: '/cust/resetpassword/:email/:resetkey',
                name: 'resetpassword',
                component: () => import('../views/custViews/ResetPassword.vue'),
                meta: {
                  title: 'ResetPassword | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Reset Password'
                    }
                  ]
                }
        },
        {
                path: '/previewbooking',
                name: 'PreviewBooking',
                component: () => import('../views/custViews/Previewbooking.vue'),
                meta: {
                title: 'PreviewBooking | Bookjoy',
                role: 'Customer',
                metaTags: [
                        {
                        name: 'description',
                        content: 'Customer Booking details.'
                        }
                ]
                }
        },
        {
                path: '/service/:serv_details/:store_name',
                name: 'singleService',
                component: () => import('../views/custViews/Service.vue'),
                meta: {
                title: 'Service | Bookjoy',
                role: 'Customer',
                metaTags: [
                        {
                        name: 'description',
                        content: 'Service details.'
                        }
                ]
                }
        },
        {
                path: '/bookingsuccess',
                name: 'bookingsuccess',
                component: () => import('../views/custViews/BookingSuccess.vue'),
                meta: {
                  title: 'Bookingsuccess | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Success Page'
                    }
                  ]
                }
        },
        {
            path: '/home/:store_name',
            name: 'category',
            component: () => import('../views/custViews/Categories.vue'),
            meta: {
              title: 'Book Appointment | Bookjoy',
              role: 'Customer',
              metaTags: [
                {
                  name: 'description',
                  content: 'Categories details.'
                }
              ]
            }
        },
        {
                path: '/cart',
                name: 'Cart',
                component: () => import('../views/custViews/Cart.vue'),
                meta: {
                  title: 'cart | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'cart details.'
                    }
                  ]
                }
        },
        {
                path: '/mailsent',
                name: 'mail',
                component: () => import('../views/custViews/MailSent.vue'),
                meta: {
                  title: 'Mail | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Mail sent Successfully'
                    }
                  ]
                }
        },
        {
                path: '/passwordupdate',
                name: 'pwdupdate',
                component: () => import('../views/custViews/PasswordUpdate.vue'),
                meta: {
                  title: 'NewPassword | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Password Updated'
                    }
                  ]
                }
        },
        {
                path: '/terms',
                name: 'terms',
                component: () => import('../views/custViews/TermsAndConditions.vue'),
                meta: {
                        title: 'Terms and Conditions | Bookjoy',
                        role: 'Customer',
                        metaTags: [
                            {
                                name: 'description',
                                content: 'Terms and Conditions Page'
                            }
                        ]
                }
        },
        {
                path: '/custpayment',
                name: 'CustPayment',
                component: () => import('../views/custViews/CustPayment.vue'),
                meta: {
                  title: 'Payment | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Payment details.'
                    }
                  ]
                }
        },
        {
                path: '/bookingdetails/:type/:book_id/:multi_service_book_id',
                name: 'CustFullbooking',
                component: () => import('../views/custViews/CustBookingDetails.vue'),
                meta: {
                  title: 'custbookingdetails | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Full Booking  details.'
                    }
                  ]
                }
        },
        {
                path: '/mybookings',
                name: 'CustUpcomingBooking',
                component: () => import('../views/custViews/CustUpcomingBooking.vue'),
                meta: {
                  title: 'custupcomingbookingdetails | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'UpComing Booking  details.'
                    }
                  ]
                }
        },
        {
                path: '/addproducts',
                name: 'CustAddProducts',
                component: () => import('../views/custViews/AddProducts.vue'),
                meta: {
                  title: 'custaddproducts | Bookjoy',
                  role: 'Customer',
                  metaTags: [
                    {
                      name: 'description',
                      content: 'Add products to cart.'
                    }
                  ]
                }
        },
        {
                path: '/inventory',
                name: 'Inventory',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/Inventory.vue'),
                meta: {
                title: 'Inventory | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The products of the store.'
                        }
                        ]
                }
        },
        {
                path: '/product',
                name: 'Product',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/ProductForm.vue'),
                meta: {
                title: 'Product | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Create and edit products of the store.'
                        }
                        ]
                }
        },
        {
                path: '/reports',
                name: 'Reports',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/Reports.vue'),
                meta: {
                title: 'Reports | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Reports of customers in the store.'
                        }
                        ]
                }
        },
        {
                path: '/analytics',
                name: 'Analytics',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/Analytics.vue'),
                meta: {
                title: 'Analytics | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Analytics of customers in the store.'
                        }
                        ]
                }
        },
        {
                path: '/settings',
                name: 'Settings',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/Settings.vue'),
                meta: {
                title: 'Settings | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'Settings of store.'
                        }
                        ]
                }
        },
        {
            path: '*',
            name: 'catchAll',
            component: () => import(/* webpackChunkName: "about" */ '../views/Error.vue'),
            meta: {
                title: 'Error | Bookjoy',
                        role: 'Admin',
                        metaTags: [
                        {
                        name: 'description',
                        content: 'The events will show on calendar.'
                        }
                        ]
             }
        }
        ]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // JOYWEB-2565: prevent customers from being stranded on /home/undefined ("No Store Found").
    // If the target is the /home/:store_name route and the slug is missing or the literal
    // string 'undefined', try to recover a valid slug from the persisted session; otherwise
    // fall back to the site root. Guard against redirect loops (never redirect back to an
    // empty/undefined slug).
    // The /home/:store_name route (name 'category') requires a param, so a bare
    // '/home' or '/home/' (empty slug) does NOT match it — it falls through to
    // catchAll. Detect both: 'category' with a bad slug, and the empty-slug /home path.
    var isHomeRoute = to.name === 'category';
    var isEmptyHomePath = /^\/home\/?$/.test(to.path);
    if (isHomeRoute || isEmptyHomePath) {
        var targetSlug = sanitizeSlug(isHomeRoute ? to.params.store_name : '');
        if (!targetSlug) {
            var sessionForSlug = {};
            try {
                sessionForSlug = JSON.parse(localStorage.getItem('vue-session-key')) || {};
            } catch (e) {
                sessionForSlug = {};
            }
            var fallbackSlug = sanitizeSlug(sessionForSlug.store_url_name);
            if (fallbackSlug) {
                next('/home/' + fallbackSlug);
            } else {
                next('/');
            }
            return;
        }
    }

    let DEFAULT_TITLE = 'Bookjoy';
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });

    // JOYWEB-2567: Klavity bug-report widget on the ADMIN side of the Vue app only.
    // Admin routes are auth-gated (customers are redirected to login below), so this never
    // loads on customer-facing pages. Injected once per session on the first admin route.
    if (to.meta && to.meta.role === 'Admin' && !document.getElementById('klavity-widget')) {
        var klavityWidget = document.createElement('script');
        klavityWidget.id = 'klavity-widget';
        klavityWidget.src = 'https://klavity.in/widget.js';
        klavityWidget.setAttribute('data-project', 'proj_35cda011-0399-45e2-8832-47817a02615e');
        klavityWidget.defer = true;
        document.head.appendChild(klavityWidget);
    }

    var session_details = JSON.parse(localStorage.getItem('vue-session-key'))
    if ((from.path.toLowerCase() == "/mybookings" && to.path.toLowerCase() == "/bookingsuccess") ||  (from.path.toLowerCase() == "/" && to.path.toLowerCase() == "/bookingsuccess")) {
        localStorage.setItem('remove_session_flag',true); 
        router.push('home/'+ session_details.store_url_name);
    }
 
   
    var events_in_clipboard = JSON.parse(sessionStorage.getItem('droped_event')) || [];
    if (!localStorage.getItem('v2_user_id') && to.meta.role == 'Admin') {
        if (window.location.hostname === 'localhost') {
//            window.location.href = 'http://' + window.location.hostname + '/index.php/user/Login';
        } else if (window.location.hostname === 'qlab.quantana.com.au') {
            this.$store.commit('setUrl', 'http://' + window.location.hostname + ':9900/index.php/user/Login');
        } else {
            window.location.href = 'https://' + window.location.hostname + '/index.php/user/Login';
        }
    } else if (events_in_clipboard.length != 0)
    {
        if (to.name == "Editbooking" || to.name == "Calendar" || to.name == "Newbooking" || to.name == "Invoice" || to.name == "Viewbooking" || to.name == "Payment")
            next();
        else
        {
            if (confirm('Clipboard will be reset if you move away from this screen. Do you wish to proceed?'))
            {
                sessionStorage.setItem("droped_event", JSON.stringify([]));
                next();
            }
        }
    } else {
        next();
    }
})

export default router
